export const inventoryZh = {
  // 操作类型
  checkIn: '入库',
  checkOut: '出库',
  inbound: '入库',
  outbound: '出库',
  adjust: '调整',
  receiving: '收货',
  return: '退货',
  adjustment: '库存调整',
  transfer: '库存转移',
  scrap: '报废',
  
  // 操作描述
  checkInDesc: '将零件入库到指定位置',
  checkOutDesc: '从库存中领取零件',
  receivingDesc: '接收供应商发货',
  returnDesc: '退回零件到供应商',
  adjustmentDesc: '调整库存数量',
  transferDesc: '在不同位置间转移',
  scrapDesc: '报废不可用零件',
  
  // 表单字段
  selectStation: '请选择工位',
  selectWarehouse: '请选择仓库',
  quantity: '数量',
  location: '位置',
  reason: '原因',
  notes: '备注',
  operator: '操作员',
  
  // 消息
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  invalidQuantity: '数量无效',
  insufficientStock: '库存不足',
  checkInFailed: '入库失败',
  checkOutFailed: '出库失败',
  reasonPlaceholder: '例如：生产领料、维修更换等',
  operations: '操作',
  recentOperations: '最近操作记录',
  
  // 库存查看页面
  title: '库存',
  logs: '操作日志',
  stats: '统计',
  operationType: '操作类型',
  
  // 统计数据
  totalOperations: '总操作数',
  totalCheckIns: '总入库',
  totalCheckOuts: '总出库',
  totalAdjustments: '总调整',
  
  // 扫描操作
  scanCode: '扫描条码',
  scanPlaceholder: '扫描或输入条码',
  enterReason: '输入原因',
  invalidCode: '无效条码',
  checkInSuccess: '入库成功',
  checkOutSuccess: '出库成功',
  scrapSuccess: '报废成功',
  transferDeveloping: '转移功能开发中',
  unsupportedOperation: '不支持的操作类型',
  
  // 其他
  currentStock: '当前库存',
  afterOperation: '操作后',
  confirmOperation: '确认操作',
};

export type InventoryTranslations = typeof inventoryZh;

